<div
  class="mam-graphic-card"
  [class.mam-graphic-card--with-edit-overlay]="showEditOverlay"
>
  <div class="mam-graphic-card__thumbnail">
    <img
      *ngIf="item.thumbnailUrl"
      [src]="item.thumbnailUrl"
      [alt]="item.title"
      class="mam-graphic-card__img"
      loading="lazy"
    />
    <div *ngIf="!item.thumbnailUrl" class="mam-graphic-card__placeholder">
      <span class="mam-graphic-card__placeholder-text">{{ item.kind === 'gfx' ? 'GFX' : 'IMG' }}</span>
    </div>
    <span *ngIf="item.kind === 'gfx' && item.durationFormatted" class="mam-graphic-card__duration">{{ item.durationFormatted }}</span>
  </div>
  <div class="mam-graphic-card__info">
    <div class="mam-graphic-card__title">{{ item.title }}</div>
    <div class="mam-graphic-card__duration-inline" *ngIf="item.kind === 'gfx' && item.durationFormatted">{{ item.durationFormatted }}</div>
  </div>

  <div *ngIf="showEditOverlay" class="mam-graphic-card__edit-overlay">
    <button
      type="button"
      class="mam-graphic-card__edit-content"
      (click)="onEditClick($event)"
      aria-label="Edit"
    >
      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.0844 9.10454C13.1091 8.90715 13.1276 8.70977 13.1276 8.50004C13.1276 8.29032 13.1091 8.09294 13.0844 7.89555L14.3859 6.87778C14.5031 6.78525 14.534 6.61871 14.46 6.483L13.2263 4.34877C13.1523 4.21306 12.9857 4.16372 12.85 4.21306L11.3141 4.8299C10.9934 4.58316 10.6479 4.37961 10.2717 4.2254L10.0373 2.5908C10.0188 2.44276 9.88923 2.33173 9.73503 2.33173H7.2677C7.11349 2.33173 6.98396 2.44276 6.96545 2.5908L6.73105 4.2254C6.35479 4.37961 6.00936 4.58933 5.68861 4.8299L4.1527 4.21306C4.01083 4.15755 3.85045 4.21306 3.77643 4.34877L2.54277 6.483C2.46258 6.61871 2.49959 6.78525 2.61679 6.87778L3.9183 7.89555C3.89363 8.09294 3.87512 8.29649 3.87512 8.50004C3.87512 8.7036 3.89363 8.90715 3.9183 9.10454L2.61679 10.1223C2.49959 10.2148 2.46875 10.3814 2.54277 10.5171L3.77643 12.6513C3.85045 12.787 4.01699 12.8364 4.1527 12.787L5.68861 12.1702C6.00936 12.4169 6.35479 12.6205 6.73105 12.7747L6.96545 14.4093C6.98396 14.5573 7.11349 14.6684 7.2677 14.6684H9.73503C9.88923 14.6684 10.0188 14.5573 10.0373 14.4093L10.2717 12.7747C10.6479 12.6205 10.9934 12.4108 11.3141 12.1702L12.85 12.787C12.9919 12.8425 13.1523 12.787 13.2263 12.6513L14.46 10.5171C14.534 10.3814 14.5031 10.2148 14.3859 10.1223L13.0844 9.10454ZM8.50136 10.659C7.31088 10.659 6.34245 9.69053 6.34245 8.50004C6.34245 7.30956 7.31088 6.34113 8.50136 6.34113C9.69185 6.34113 10.6603 7.30956 10.6603 8.50004C10.6603 9.69053 9.69185 10.659 8.50136 10.659Z"
          fill="currentColor"
        />
      </svg>
      <span>Edit</span>
    </button>
  </div>
</div>
